import axios from "../utils/axios";

export class PatientService {
  getAllPatients(params?: Record<string, any>) {
    return axios.get("/patients", { params });
  }
  getPatientByApi(patientId: string) {
    return axios.get(`/patients/${patientId}`);
  }
  exportPatients() {
    return axios.get("/patients/export/csv");
  }
  getPatientName(patientId: string) {
    return axios.get(`/patients/${patientId}/info`);
  }
  createPatient(data: any) {
    return axios.post("/patients", data);
  }
  updatePatient(id: any, data: any) {
    return axios.put(`/patients/${id}`, data);
  }
  deletePatient(id: any, data?: any) {
    return axios.delete(`/patients/${id}`, data);
  }
  checkDuplicateByNameDob(firstName: string, surName: string | undefined, dateOfBirthISO: string) {
    const params = new URLSearchParams({ firstName, date_of_birth: dateOfBirthISO });
    if (surName) params.append('surName', surName);
    return axios.get(`/patients/check-duplicate?${params.toString()}`);
  }
}
